import { Component, OnInit } from '@angular/core';
import { OwnerCo } from '@model/syndic/owner-co';
import { OwnerCredit } from '@model/syndic/owner-credit';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EmitterService } from '@service/emitter/emitter.service';
import { OwnerCoService } from '@service/syndic/owner-co.service';
import { OwnerCreditService } from '@service/syndic/owner-credit.service';
import Swal from 'sweetalert2/dist/sweetalert2.js';

@Component({
  selector: 'app-owner-co-show',
  templateUrl: './owner-co-show.component.html',
  styleUrls: ['./owner-co-show.component.scss']
})
export class OwnerCoShowComponent implements OnInit {

  ownerCo: OwnerCo;
  credits: OwnerCredit[] = [];
  balance: any = {};
  activeTab: string = 'INFO';

  constructor(
    public modal: NgbActiveModal,
    private ownerCoService: OwnerCoService,
    private ownerCreditService: OwnerCreditService,
    private emitter: EmitterService
  ) {
    this.ownerCo = this.ownerCoService.getOwnerCo();
  }

  ngOnInit(): void {
    if (this.ownerCo?.uuid) {
      this.loadBalance();
      this.loadCredits();
    }
  }

  loadBalance(): void {
    this.ownerCoService.getBalance(this.ownerCo.uuid).subscribe((res: any) => {
      this.balance = res || {};
    });
  }

  loadCredits(): void {
    this.ownerCreditService.getList(this.ownerCo.uuid).subscribe((res: any) => {
      this.credits = res || [];
    });
  }

  addCredit(type: string): void {
    Swal.fire({
      title: type === 'CREDIT' ? 'Ajouter un crédit' : 'Ajouter un débit',
      html: `
        <input id="swal-montant" class="swal2-input" placeholder="Montant" type="number">
        <input id="swal-motif" class="swal2-input" placeholder="Motif">
        <input id="swal-reference" class="swal2-input" placeholder="Référence">
      `,
      showCancelButton: true,
      confirmButtonText: 'Enregistrer',
      cancelButtonText: 'Annuler',
      preConfirm: () => {
        const montant = (document.getElementById('swal-montant') as HTMLInputElement).value;
        const motif = (document.getElementById('swal-motif') as HTMLInputElement).value;
        const reference = (document.getElementById('swal-reference') as HTMLInputElement).value;
        if (!montant) {
          Swal.showValidationMessage('Le montant est obligatoire');
        }
        return { montant: Number(montant), motif, reference, type, ownerCo: this.ownerCo.uuid };
      }
    }).then((result) => {
      if (result.isConfirmed) {
        this.ownerCreditService.add(result.value).subscribe((res: any) => {
          if (res?.status === 'success') {
            this.loadBalance();
            this.loadCredits();
            Swal.fire({ icon: 'success', title: 'Succès', text: res?.message });
          }
        });
      }
    });
  }

  deleteCredit(item: OwnerCredit): void {
    Swal.fire({
      title: 'Êtes-vous sûr ?',
      text: 'Cette action est irréversible !',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Oui, supprimer !',
      cancelButtonText: 'Non, annuler'
    }).then((result) => {
      if (result.isConfirmed) {
        this.ownerCreditService.getDelete(item.uuid).subscribe((res: any) => {
          if (res?.status === 'success') {
            this.loadBalance();
            this.loadCredits();
            Swal.fire({ icon: 'success', title: 'Succès', text: res?.message });
          }
        });
      }
    });
  }

  onClose(): void {
    this.modal.close('ferme');
  }
}
